const mapWeatherConfig = {
  maximum: 5, // MaximummakeRequests
  scatteredS3ZonesDataStep: 50, // scatteredS3ZonesDataStep
};

export default mapWeatherConfig;
